export enum SelectedFileStatus {
  Ready = 'Ready to Upload',
  Uploading = 'Uploading',
  Success = 'Complete',
  Error = 'Failed to Upload',
}
